import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNearmecircleFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m4.216 5.948a.515.515 0 0 0-.664-.664l-8.47 3.198a.515.515 0 0 0-.131.89.5.5 0 0 0 .225.083l3.794.672c.08.014.16.034.225.083a.5.5 0 0 1 .095.095c.05.064.07.145.083.225l.672 3.794c.014.08.034.16.083.225a.515.515 0 0 0 .89-.132z",
    clipRule: "evenodd"
  }));
}
var IcNearmecircleFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNearmecircleFill));

export { IcNearmecircleFill as I };
